export default "__VITE_ASSET__d49c33f3__"